module.exports = __webpack_public_path__ + "assets/img/1369f5dd7bdb926ecb8917696f25da8b.svg";